import { alpha } from "@mui/material/styles";

export function getSchedulingEventColors(theme) {
  return {
    tournamentTextColor: theme.palette.common.white,
    proposed: {
      backgroundColor: alpha(theme.palette.primary.main, 0.34),
      borderColor: theme.palette.primary.main,
      textColor: theme.palette.text.primary,
    },
    conflict: {
      backgroundColor: alpha(theme.palette.warning.main, 0.3),
      borderColor: theme.palette.warning.main,
      textColor: theme.palette.text.primary,
    },
    booking: {
      backgroundColor: theme.palette.grey[300],
      borderColor: theme.palette.grey[500],
      textColor: theme.palette.common.white,
    },
    closure: {
      backgroundColor: alpha(theme.palette.info.main, 0.2),
      borderColor: theme.palette.info.main,
      textColor: theme.palette.text.primary,
    },
  };
}

export function getTournamentEventColors(theme) {
  return [
    theme.palette.primary.dark,
    theme.palette.secondary.dark,
    theme.palette.info.dark,
    theme.palette.success.dark,
    theme.palette.error.dark,
    theme.palette.warning.dark,
    theme.custom.extra.tealDark,
    theme.custom.extra.tealGreen,
    theme.palette.primary.main,
    theme.palette.secondary.main,
    theme.palette.info.main,
    theme.palette.success.main,
  ];
}

export function getCalendarSurfaceStyles(theme) {
  return {
    "--fc-border-color": theme.palette.divider,
    "--fc-page-bg-color": theme.palette.background.paper,
    "--fc-neutral-bg-color": theme.palette.background.default,
    "--fc-list-event-hover-bg-color": theme.palette.action.hover,
    "--fc-today-bg-color": alpha(theme.palette.primary.main, 0.08),
    "--fc-button-bg-color": theme.palette.background.paper,
    "--fc-button-border-color": theme.palette.divider,
    "--fc-button-hover-bg-color": theme.palette.action.hover,
    "--fc-button-hover-border-color": theme.palette.primary.main,
    "--fc-button-active-bg-color": alpha(theme.palette.primary.main, 0.24),
    "--fc-button-active-border-color": theme.palette.primary.main,
    color: theme.palette.text.primary,
    "& .fc .fc-button": {
      color: theme.palette.text.primary,
      boxShadow: "none",
      textTransform: "none",
    },
    "& .fc .fc-col-header-cell-cushion, & .fc .fc-timegrid-axis-cushion, & .fc .fc-timegrid-slot-label-cushion": {
      color: theme.palette.text.secondary,
    },
    "& .scheduling-occupancy": {
      backgroundImage: `repeating-linear-gradient(135deg, transparent, transparent 6px, ${alpha(theme.palette.common.white, 0.14)} 6px, ${alpha(theme.palette.common.white, 0.14)} 12px)`,
    },
    "& .scheduling-booking": { opacity: 0.64 },
  };
}
